// @ts-ignore
import React, { useState, useCallback } from "react";

/**
 * formData is intentionally typed as `T & Record<string, any>`:
 * callers grow the object incrementally via `onChange` spreads, so
 * keys beyond the initial shape are part of the contract.
 */
function useFormData<T extends Record<string, any>>(initialFormData: T = {} as T) {
  const [formData, setFormData] = useState<T & Record<string, any>>(initialFormData);
  const onChange = useCallback((update: any) => {
    setFormData((prev) => ({ ...prev, ...update }));
  }, []);
  return { formData, setFormData, onChange };
}

export default useFormData;
